import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lmkt_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-logout on 401 (expired/invalid token) — redirect to login
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401) {
      // Don't redirect for login attempts (let the page show its own error)
      const isLoginCall = url.includes("/auth/login");
      const onLoginPage =
        typeof window !== "undefined" &&
        window.location.pathname.startsWith("/admin/login");
      if (!isLoginCall && !onLoginPage) {
        clearAuth();
        if (typeof window !== "undefined") {
          window.location.replace("/admin/login");
        }
        // Block further chain: never resolves -> page is being navigated away
        return new Promise(() => {});
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const setAuth = (token, user) => {
  localStorage.setItem("lmkt_token", token);
  localStorage.setItem("lmkt_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("lmkt_token");
  localStorage.removeItem("lmkt_user");
};
export const getUser = () => {
  const raw = localStorage.getItem("lmkt_user");
  return raw ? JSON.parse(raw) : null;
};
export const getToken = () => localStorage.getItem("lmkt_token");
